import client from 'app/client';
import { AddressDto, OperationResponse } from 'api/actor';

/** Bank account row sent at compagnie creation (shared acteur shape). */
export interface CreateCompagnieBankAccountDto {
  iban: string;
  label: string;
  bic?: string | null;
  isDefault: boolean;
}

/**
 * Full creation of a compagnie d'assurance (ABP user + PM nature CIE).
 * No ORIAS/RCP (insurer, not intermediary); plateformes optional — a
 * compagnie can exist as a pure risk carrier.
 */
export interface CreateCompagnieCommand {
  companyName: string;
  address: AddressDto;
  /** Téléphone de l'entreprise (standard), facultatif. */
  phone?: string | null;
  /** Gérant juridique : civilité et mobile, requis. */
  gerant: { civiliteId: string; phone: string };
  registrationNumber: string;
  capital: number;
  rcsCity: string;
  rcsNumber: string;
  bankAccounts: CreateCompagnieBankAccountDto[];
  firstName: string;
  lastName: string;
  email: string;
  username: string;
  password: string;
  plateformeIds: string[];
}

export async function createCompagnie(
  command: CreateCompagnieCommand
): Promise<OperationResponse> {
  const { data } = await client.post<OperationResponse>(
    '/backoffice/compagnies/creation',
    command
  );
  return data;
}
